export default function () {
    const pageAnchors = document.querySelectorAll(".page-anchor");

    if (pageAnchors.length) {
        const anchorNav = document.createElement("div");
        const anchorNavUl = document.createElement("ul");
        const body = document.querySelector("main");

        for (let x = 0; x < pageAnchors.length; x++) {
            const anchorNavLi = document.createElement("li");
            const anchorNavLink = document.createElement("a");

            anchorNavLink.setAttribute(
                "href",
                window.location.pathname +
                    "#" +
                    pageAnchors[x].getAttribute("id")
            );
            anchorNavLink.innerText =
                pageAnchors[x].firstElementChild.innerText;
            anchorNavLi.appendChild(anchorNavLink);
            anchorNavUl.appendChild(anchorNavLi);
        }

        anchorNav.className = "anchor-nav";
        anchorNav.appendChild(anchorNavUl);
        body.parentNode.insertBefore(anchorNav, body);

        window.addEventListener("scroll", function () {
            for (var x = 0; x < pageAnchors.length; x++) {
                const nextElement =
                    pageAnchors[x].nextElementSibling &&
                    pageAnchors[x].nextElementSibling.className !== "anchor"
                        ? pageAnchors[x].nextElementSibling
                        : pageAnchors[x].nextElementSibling.nextElementSibling;
                const isCurrent =
                    nextElement.getBoundingClientRect().top <= 150 &&
                    nextElement.getBoundingClientRect().bottom >= 150;

                if (isCurrent && !nextElement.classList.contains("active")) {
                    anchorNavUl.children[x].classList.add("active");
                    nextElement.classList.add("active");
                } else if (
                    !isCurrent &&
                    nextElement.classList.contains("active")
                ) {
                    anchorNavUl.children[x].classList.remove("active");
                    nextElement.classList.remove("active");
                }
            }
        });

        const mainNavigation = document.querySelector("header");
        let mainNavigationHeight = mainNavigation.offsetHeight;
        const anchorNavigation = document.querySelector(".anchor-nav");
        let anchorNavigationTop = anchorNavigation.offsetTop;
        const mainContent = document.querySelector(
            "main section:first-of-type"
        );

        anchorNavigation.style.top = mainNavigationHeight + "px";

        function stickyAnchorNav() {
            if (window.scrollY >= anchorNavigationTop - mainNavigationHeight) {
                mainContent.style.paddingTop =
                    anchorNavigation.offsetHeight + "px";
                anchorNavigation.classList.add("sticky-nav");
            } else {
                mainContent.style.paddingTop = 0;
                anchorNavigation.classList.remove("sticky-nav");
            }
        }

        // Add event listener for the click event on the button with class 'close-bar'
        window.onload = (event) => {
            document
                .querySelector(".close-bar")
                .addEventListener("click", function () {
                    // Recheck the height of the mainNavigation
                    mainNavigationHeight =
                        document.querySelector(".header-main").offsetHeight;

                    // Reset the top position of anchorNavigation based on the new height
                    anchorNavigation.style.top = mainNavigationHeight + "px";

                    // Optionally, call stickyAnchorNav to reapply the sticky logic with the updated height
                    stickyAnchorNav();
                });
        };

        // Call the stickyAnchorNav function on scroll
        window.addEventListener("scroll", stickyAnchorNav);
    }
}
